export const ROUTE_PUBLIC_ROOT = "";
export const ROUTE_PUBLIC_EXTENSION_INSTALLED = "extension-installed";
export const ROUTE_PUBLIC_SIGN_IN = "sign-in";
export const ROUTE_PUBLIC_SIGN_UP = "sign-up";
export const ROUTE_PUBLIC_ACCEPT_INVITATION = "accept-invitation/:email/:token";
export const ROUTE_PUBLIC_FORGOT_PASSWORD = "forgot-password";
export const ROUTE_PUBLIC_RESET_PASSWORD = "reset-password/:email/:token";
export const BASE_API_URL = process.env.APP_URL + "/api";

export const ROUTE_DASHBOARD_ROOT = "dashboard";
export const ROUTE_DASHBOARD_GEARS = "gears";
export const ROUTE_DASHBOARD_MY_GEARS = "gears/self";
export const ROUTE_DASHBOARD_GEAR_CREATE = "gears/create";
export const ROUTE_DASHBOARD_GEAR_DETAIL = "gears/:id";
export const ROUTE_DASHBOARD_GEAR_EDIT = "gears/:id/edit";

export const ROUTE_DASHBOARD_TAGS = "tags";
export const ROUTE_DASHBOARD_TAG_CREATE = "tags/create";
export const ROUTE_DASHBOARD_TAG_DETAIL = "tags/:id";
export const ROUTE_DASHBOARD_TAG_EDIT = "tags/:id/edit";

export const ROUTE_DASHBOARD_ROLES = "roles";
export const ROUTE_DASHBOARD_ROLE_CREATE = "roles/create";
export const ROUTE_DASHBOARD_ROLE_DETAIL = "roles/:id";
export const ROUTE_DASHBOARD_ROLE_EDIT = "roles/:id/edit";

export const ROUTE_DASHBOARD_USERS = "users";
export const ROUTE_DASHBOARD_USER_CREATE = "users/create";
export const ROUTE_DASHBOARD_USER_DETAIL = "users/:id";
export const ROUTE_DASHBOARD_USER_EDIT = "users/:id/edit";

export const ROUTE_DASHBOARD_PROFILE = "profile";
export const ROUTE_DASHBOARD_ORGANIZATION = "organization";
export const ROUTE_DASHBOARD_ORGANIZATIONS = "organizations";
export const ROUTE_DASHBOARD_ORGANIZATIONS_VIEW = "organizations/:id";
export const ROUTE_DASHBOARD_ORGANIZATION_EDIT = "organization/:id/edit";
export const ROUTE_DASHBOARD_WELCOME = "welcome";

export const ROUTE_DASHBOARD_SUPER_ADMIN = "super-admin";
export const ROUTE_DASHBOARD_SUPER_ADMIN_ORGANIZATIONS = "super-admin/organizations";
export const ROUTE_DASHBOARD_SUPER_ADMIN_ORGANIZATION_DETAIL = "super-admin/organizations/:id";
export const ROUTE_DASHBOARD_SUPER_ADMIN_USERS = "super-admin/users";
export const ROUTE_DASHBOARD_SUPER_ADMIN_USER_DETAIL = "super-admin/users/:id";